import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IAdminAccountDetail, IAdminAccountForm } from "interfaces";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AdminAccountForm } from "./components";

export const EditAdminAccount: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate, isLoading: isUpdating } = useUpdate();
  const navigate = useNavigate();

  const { data, isFetching, isPreviousData, isLoading } =
    useOne<IAdminAccountDetail>({
      resource: "admin-account/account",
      id: params?.id,
      meta: {
        resource: "data",
      },
      queryOptions: {
        enabled: !!params?.id,
      } as any,
    });

  const accountDetail = data?.data ?? null;

  const onSubmit = (values: IAdminAccountForm) => {
    const submitValues = { ...values };
    const id = params?.id;
    if (id) {
      mutate(
        {
          resource: "admin-account/account",
          id: id,
          meta: {
            ignoreResourceWrapper: true,
          },
          values: {
            ...submitValues,
          },
        },
        {
          onSuccess: () => {
            toast.success("Edit successfully");
            navigate(`/admin-accounts/accounts/${id}`);
          },
        }
      );
    }
  };

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Admin account" />
      {accountDetail ? (
        <AdminAccountForm
          defaultData={accountDetail}
          onSubmit={onSubmit}
        />
      ) : (
        <></>
      )}
      {(isFetching && isPreviousData) || isUpdating ? (
        <FullScreenLoading />
      ) : (
        <></>
      )}
    </div>
  );
};
